/* eslint-disable no-console */
import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { AppRouter } from "routes/AppRouter";
import { getRobotTxt, getTagManagerId } from "api/services/userAuth.api";
import { useAppSelector } from "hooks/reduxHooks";
import "./App.css";

function App() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const lockerDetails: any = useAppSelector((state) => state.landingPage.lockerPortalDetails);
  const [trackingId, setTrackingId] = useState<string | null>(null);

  const loadScript = (src: string, isAsync: boolean, data: string) => {
    const script = document.createElement("script");
    script.setAttribute("src", src);
    script.setAttribute("type", "text/javascript");
    script.setAttribute("async", `${isAsync}`);
    document.body.appendChild(script);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const script2: any = document.createElement("script");
    if (script2) {
      script2.setHTMLUnsafe(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${data}');`);
      script2.setAttribute("type", "text/javascript");
      script2.setAttribute("async", `${isAsync}`);
      document.head.appendChild(script2);
    }
  };

  useEffect(() => {
    if (lockerDetails !== "{}" && lockerDetails?.lockerPortalDetails?.PortalId) {
      getTagManagerId(lockerDetails?.lockerPortalDetails?.PortalId)
        .then((res) => {
          loadScript(
            `https://www.googletagmanager.com/ns.html?id=${res.data.TagManagerModel.ContainerId}`,
            false,
            res.data.TagManagerModel.ContainerId
          );
          setTrackingId(res.data.TagManagerModel.AnalyticsUId);
        })
        .catch((e) => console.error("Failed to get tracking ID", e));
      getRobotTxt(lockerDetails?.lockerPortalDetails?.PortalId)
        .then((res) => {
          if (res.data.RobotsTxt.DefaultRobotTag !== "None") {
            const contentVal = res.data.RobotsTxt.DefaultRobotTag.split("_");
            const metaTag = document.createElement("meta");
            metaTag.name = "robots";
            metaTag.content = `${contentVal[0]},${contentVal[1]}`;
            document.head.appendChild(metaTag);
          }
        })
        .catch((e) => console.error("Failed to get tracking ID", e));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lockerDetails]);

  useEffect(() => {
    if (trackingId) {
      ReactGA.initialize(trackingId);
      ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }
  }, [trackingId]);

  // eslint-disable-next-line react/react-in-jsx-scope
  return <AppRouter />;
}

export default App;
